import type { SelectValue } from 'antd/lib/select/index';
import React from 'react';
import styled from 'styled-components/macro';
import { useSelector, useDispatch } from 'react-redux';
import { Select as AntdSelect } from 'antd';
import { FormattedMessage } from 'react-intl';
import {
  setIsActive,
  getIsActiveAsNumber,
} from 'routes/tourOperator/flightCache/flightRoutes/comp/flightRoutesFilters';
import LabeledValue from 'comp/dataPresentation/labeledValue/LabeledValue';
import mediaQuery from 'styles/utils/mediaQuery';

const options = [
  { value: 0, label: 'No' },
  { value: 1, label: 'Yes' },
];

function IsActive(): JSX.Element {
  const value = useSelector(getIsActiveAsNumber);
  const dispatch = useDispatch();

  function handleOnChange(option: SelectValue) {
    if (option === undefined) {
      dispatch(setIsActive(null));
    } else {
      dispatch(setIsActive(!!option));
    }
  }

  return (
    <LabeledValue label={{ id: 'isActive' }}>
      <Select
        allowClear
        placeholder={<FormattedMessage id='isActive.placeholder' />}
        options={options}
        value={value}
        onChange={handleOnChange}
      />
    </LabeledValue>
  );
}

export default IsActive;

const Select = styled(AntdSelect)`
  width: 100%;

  ${mediaQuery.fromAndAbove.medium`
    width: 200px;
  `}
`;
